import sha256 from 'sha256'
import Crypto from './Crypto'
import {create} from 'zustand'
import { Instance } from './App'

export const APIError = create((set) => ({
	Error: undefined,
}))

let Challenge = undefined
let APIQueue = new Promise(r=>r())
let RecurseLimiter = 0

export default async function API(Command, ...Args) {
    const PreviousAPILock = APIQueue
    let ReleaseLock
    APIQueue = new Promise(R=>ReleaseLock=R)
    setTimeout(()=>ReleaseLock(), 500)
    await PreviousAPILock

    const APIToken = localStorage.getItem('Token')

    console.log("API Request", Command, Args)
    Request = JSON.stringify({Command, Args})
    let Key = undefined
    const Timestamp = new Date().getUTCMilliseconds()
    if (Challenge) {
        const Hash = sha256(Challenge + Request)
        Key = Crypto.Key.sign(Hash).toHex()
    }
    let Response = await fetch('/ui/API', {
        method: 'post',
        headers: {
            'Token': APIToken,
            'Timestamp': Timestamp,
            ...Key?{'Challenge':Challenge,'Key': Key}:{},
        },
        body: Request,
    })
    const NewChallenge = Response.headers.get('Challenge')
    if (NewChallenge)
        Challenge = NewChallenge
    if (Response.status == 401) {
        localStorage.removeItem('DeviceSecret')
        localStorage.removeItem('Token')
        window.location.reload()
        return
    }
    if (Response.status == 403) {
        if (NewChallenge && RecurseLimiter++ < 100) {
            ReleaseLock()
            return API(Command, ...Args)
        } else {
			localStorage.removeItem('DeviceSecret')
			localStorage.removeItem('Token')
			window.location.reload()
		}
    }
    Response = await Response.json()
    console.log('API Response', Command, Response)
	if (Response?.Error) {
		console.log({Error:"Error: " + Response.Error})
		Instance?.setState({Error:"Error: " + Response.Error})
	}
	RecurseLimiter = 0
    ReleaseLock()
    return Response
}